import { DAILY_REVENUE, MONTHLY_REVENUE, ALERTS, KPI_SNAPSHOT, BRANCHES } from "./data";
import { HISTORICAL_MONTHLY } from "./dataHistorical";

// Pilot (inventory & demand) derivations from the synthetic sample dataset.
const AVG_UNIT_PRICE = 2450;
const AVG_UNIT_COST = 1850;
const SEASONALITY = [0.86, 0.94, 1.20, 1.34, 1.30, 1.10, 0.96, 0.92, 0.94, 1.04, 1.10, 1.00];

const wobble = (i, amp) => 1 + Math.sin(i * 1.7) * amp + Math.cos(i * 0.6) * amp * 0.5;
const units = (php) => Math.round(php / AVG_UNIT_PRICE);

export const DEMAND_SERIES = {
  "30D": DAILY_REVENUE.map((d, i) => {
    const actual = units(d.total);
    return { x: d.date, actual, forecast: Math.round(actual * wobble(i, 0.08)) };
  }),
  "12M": MONTHLY_REVENUE.map(d => ({ x: d.month, actual: units(d.revenue), forecast: units(d.target) })),
  "48M": HISTORICAL_MONTHLY.map(d => ({ x: d.label, actual: units(d.revenue), forecast: units(d.target) })),
};

export function accuracyOf(series) {
  const errs = series.filter(p => p.actual).map(p => Math.abs(p.forecast - p.actual) / p.actual);
  return errs.length ? 1 - errs.reduce((s, e) => s + e, 0) / errs.length : 0;
}

export const DEMAND_OUTLOOK = (() => {
  const last30 = DEMAND_SERIES["30D"].reduce((s, p) => s + p.actual, 0);
  const m = new Date().getMonth();
  const next30 = Math.round((last30 * SEASONALITY[(m + 1) % 12]) / SEASONALITY[m]);
  return { last30, next30, delta: (next30 - last30) / last30, accuracy: KPI_SNAPSHOT.forecastAccuracy };
})();

const NETWORK_SALES = BRANCHES.reduce((s, b) => s + b.monthlyActual, 0);

// Branch outlook = network outlook × the branch's share of network sell-through.
export function demandOutlookFor(branchId) {
  const b = branchId && BRANCHES.find(x => x.id === branchId);
  if (!b) return { ...DEMAND_OUTLOOK, scope: "Network" };
  const share = b.monthlyActual / NETWORK_SALES;
  return { ...DEMAND_OUTLOOK, scope: b.name,
           last30: Math.round(DEMAND_OUTLOOK.last30 * share), next30: Math.round(DEMAND_OUTLOOK.next30 * share) };
}

export const HEALTH_META = {
  healthy: { label: "Healthy", tone: "success" },
  at_risk: { label: "At risk", tone: "critical" },
  excess:  { label: "Excess",  tone: "warning" },
};

export function branchHealth(b) {
  if (b.stockoutRate > 0.06) return "at_risk";
  if (b.overstockRate > 0.12 || b.daysOnHand > 60) return "excess";
  return "healthy";
}

export function forecastDemand30(b, value) {
  return Math.round((((value ?? b.inventoryValue) / b.daysOnHand) * 30) / AVG_UNIT_COST);
}

export const isPilotAlert = (a) => a.kind !== "anomaly" || /demand/i.test(a.text);
export const PILOT_ALERTS = ALERTS.filter(isPilotAlert);

export const PILOT_COPILOT_SUGGESTIONS = [
  "Which branches are most at risk of stockout this week?",
  "What is driving Ending Inventory value by category?",
  "Summarise today's top engine recommendations",
  "Which suppliers need escalation?",
  "Where is demand outpacing the forecast?",
  "Which excess stock should we redistribute first?",
];
